import React from "react";
import "./Premier.css";
import Premier1 from "../../Images/premier1.png";
import star from "../../Images/Group 1321315499.png";

const features = [
  "Unlimited Links, Zero Cost",
  "Customizable Themes",
  "Powerful Insights",
  "Seamless Redirection",
];

const Premier = ({handlePopup}) => {
  return (
    <div className="premier-landing-page">
      <div className="premier-container">
        <h1 className="premier-main-title">
          Features Like No Other- Cost as Low as Zero.
        </h1>
        <p className="premier-subtitle">
          Bring Your Audience to the Playground of Monetization
        </p>

        <div className="premier-content">
          <div className="premier-text-content">
            <span className="premier-badge">Businessbay Wall</span>

            <h2 className="premier-secondary-title">
              Your Bio, Your Brand—Simplified with Businessbay Wall
            </h2>

            <p className="premier-feature-list-p1">
              Why settle for the ordinary when your bio can be extraordinary?
              With, <br />
              <span className="highlight">Businessbay Wall,</span> transform your bio into a dynamic hub that connects  <br /> 
              your audience to everything you offer—effortlessly and elegantly.
            </p>
           


            <ul className="premier-feature-list">
              {features.map((feature, idx) => (
                <li key={idx} className="premier-feature-list-item premier-feature-list-container">
                  <img src={star} alt="star" className="star" loading="lazy" />
                  {feature}
                </li>
              ))}
            </ul>   


            <button className="premier-cta-button" onClick={handlePopup}>
              Let's Dive In
              <span className="arrow">→</span>
            </button>
          </div>

          <div className="premier-image-container">
            <img
              src={Premier1}
              alt="Mobile App Preview"
              className="mobile-preview"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Premier;
